import { motion } from "framer-motion";
import { INSTALLATION_VIDEOS } from "@/data/products";
import { MapPin, User } from "lucide-react";

export default function VideoShowcase() {
  return (
    <section
      id="installations"
      data-testid="video-showcase-section"
      className="relative py-24 md:py-32 bg-ink-deep text-cream-100 overflow-hidden"
    >
      {/* subtle gold pattern */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 25%, #D4A93A 1px, transparent 1px), radial-gradient(circle at 80% 75%, #D4A93A 1px, transparent 1px)",
          backgroundSize: "70px 70px",
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="text-[11px] tracking-[0.32em] uppercase text-gold-light mb-4">
            — Watch the Craft
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            From our workshop
            <br />
            <span className="italic gold-text">to your home.</span>
          </h2>
          <p className="text-cream-100/70 mt-6 text-base leading-relaxed max-w-xl mx-auto">
            Real installations, real homes. Watch our carved temples come alive
            at client sites across India and the world.
          </p>
        </div>

        <div
          className={`grid gap-10 ${
            INSTALLATION_VIDEOS.length === 1
              ? "max-w-3xl mx-auto"
              : "md:grid-cols-2"
          }`}
        >
          {INSTALLATION_VIDEOS.map((v, i) => (
            <motion.figure
              key={v.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="relative">
                <div className="absolute inset-0 -m-3 border border-gold/30 pointer-events-none" />
                <div className="relative overflow-hidden bg-black border border-gold/40">
                  <video
                    src={v.src}
                    poster={v.poster}
                    controls
                    preload="metadata"
                    playsInline
                    className="w-full aspect-[4/5] sm:aspect-[4/4] md:aspect-[4/5] object-cover"
                    data-testid={`installation-video-${i}`}
                  />
                </div>
              </div>
              <figcaption className="mt-6 text-center">
                <div className="font-serif text-2xl text-cream-100">
                  {v.title}
                </div>
                {(v.location || v.client) && (
                  <div className="flex items-center justify-center gap-5 mt-3 text-[11px] tracking-[0.24em] uppercase text-gold-light">
                    {v.location && (
                      <span className="flex items-center gap-2">
                        <MapPin className="w-3.5 h-3.5" />
                        {v.location}
                      </span>
                    )}
                    {v.client && (
                      <span className="flex items-center gap-2">
                        <User className="w-3.5 h-3.5" />
                        {v.client}
                      </span>
                    )}
                  </div>
                )}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
